import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    flex: {
      display: "flex"
    },
    center: {
      marginRight: "auto",
      marginLeft: "auto"
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2)
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    spinnerContainer: {
      position: "absolute",
      backgroundColor: "rgba(255,255,255,0.8)",
      zIndex: 100,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  })
);
